/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

/**
 * Lifecycle status of the job
 */
export enum BulkAddCounterpartyJobStatus {
    INITIATED = 'INITIATED',
    PREPARING = 'PREPARING',
    IN_PROGRESS = 'IN_PROGRESS',
    COMPLETED = 'COMPLETED',
    FAILED = 'FAILED',
}
